import React, { useContext } from "react";
import { TIME_RANGE_1_MONTHS } from "@shared/common/constants";
import TradingViewChart from "common/Charts/TradingViewChart";
import EmptyView from "common/Empty/EmptyView";
import useTradingTerminalChart from "@shared/features/tradingTerminal/common/hooks/useTradingTerminalChart";
import { EmptyStatesType } from "common/Icons/types.ts";
import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context.tsx";
import styled from "styled-components";
import ExchangeSelectionDropdown from "features/portfolio/Assets/ExchangeSelectionDropdown.tsx";
import Flex from "common/Boxes/Flex";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import { useTradingViewChartExchangeSelector } from "features/tradingTerminal/common/hooks.ts";

interface TradingTerminalChartProps {
  isCard?: boolean;
}

const TradingTerminalChart = ({ isCard }: TradingTerminalChartProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADING_TERMINAL);
  const { symbols, exchanges, annotations, showEmptyState, freeTextProcessed } =
    useTradingTerminalChart();
  const { isSignal, useTradingTerminalOldVersion, account } = useContext(
    TradingTerminalContext
  )!;
  const symbol = symbols[0];
  const { symbolExchanges, setExchange, exchange } =
    useTradingViewChartExchangeSelector({
      exchanges,
      symbol,
    });

  return showEmptyState ? (
    <EmptyView
      iconKey={EmptyStatesType.Graph}
      iconWidth={120}
      title={t("modals.no_data")}
    />
  ) : (
    <ChartWrapper>
      {!useTradingTerminalOldVersion && isSignal && (
        <Flex $justifyContent="flex-end">
          <ExchangeSelectionDropdown
            exchange={exchange}
            exchanges={symbolExchanges}
            setExchange={setExchange}
          />
        </Flex>
      )}
      <TradingViewChart
        symbol={symbol}
        exchange={exchange ?? account?.exchange}
        annotations={annotations}
        defaultTimeRange={TIME_RANGE_1_MONTHS}
        showExtendButton={true}
        isCard={isCard}
        shouldFitToOrders={freeTextProcessed}
      />
    </ChartWrapper>
  );
};

export default TradingTerminalChart;

const ChartWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
